module.exports = __webpack_public_path__ + "media/img/vca/prizes/vrworld-5e628202422325bcc4c1f11ce1503a34.png";